import { Component, inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle';
import {
  MatButtonToggle,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { API_PARAMS } from '../../shared/constants/api.constants';
import { DevService } from '../../shared/services/dev.service';
import { MatDialog } from '@angular/material/dialog';
import { OtpDialogComponent } from '../../shared/components/dialogs/otp-dialog/otp-dialog.component';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { STORAGE_KEY } from '../../shared/constants/store-key.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterVerifyContactService } from '../../shared/services/register-verify-contact.service';
import { CreateMemberRequest } from '../../shared/interfaces/set-password.model';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { ToastrService } from 'ngx-toastr';

/**
 * 聯絡方式驗證組件
 */
@Component({
  selector: 'app-register-verify-contact',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButton,
    TranslatePipe,
    MatSlideToggle,
    FormsModule,
    MatButtonToggleGroup,
    MatButtonToggle,
    NgClass,
    NgOptimizedImage,
  ],
  templateUrl: './register-verify-contact.component.html',
  styleUrl: './register-verify-contact.component.scss',
})
export class RegisterVerifyContactComponent implements OnInit {
  translateService: TranslateService = inject(TranslateService);
  devService: DevService = inject(DevService);
  dialog: MatDialog = inject(MatDialog);
  registerVerifyContactService: RegisterVerifyContactService = inject(
    RegisterVerifyContactService
  );
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  router: Router = inject(Router);
  route: ActivatedRoute = inject(ActivatedRoute);
  toastr: ToastrService = inject(ToastrService);
  // TODO 自訂驗證器
  // 聯絡方式驗證表單
  verifyForm = new FormGroup({
    phone: new FormControl('', [
      Validators.required,
      Validators.maxLength(10),
      (control: FormControl) => this.phoneValidator(control),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      (control: FormControl) => this.emailValidator(control),
    ]),
  });

  phoneNumber: string = '';
  email: string = '';
  idNumber: string = '';
  lastVerifiedPhone: string = '';
  lastVerifiedEmail: string = '';
  showPhoneError: boolean = false;
  showEmailError: boolean = false;
  emailOtpCooldown: number = 0;
  phoneOtpCooldown: number = 0;
  private cooldownInterval: any;
  private phoneCooldownInterval: any;
  private isUpdatingValidation = false;
  // 統一的 OTP 倒數變數
  otpCooldown: number = 0;
  private otpCooldownInterval?: any;

  ngOnInit(): void {
    // 恢復倒數狀態
    this.restoreOtpCooldown();

    const memberData = this.sharedStorageService.get(
      STORAGE_KEY.CREATE_MEMBER_REQUEST
    );
    const idLoginData = this.sharedStorageService.get(
      STORAGE_KEY.ID_LOGIN_REQUEST
    );

    console.log('memberData:', memberData);
    console.log('idLoginData:', idLoginData);
    console.log('memberData?.idNo:', memberData?.idNo);
    console.log('idLoginData?.idNo:', idLoginData?.idNo);

    this.idNumber =
      (memberData?.idNo && memberData.idNo.trim()) ||
      (idLoginData?.idNo && idLoginData.idNo.trim()) ||
      '';
    console.log('Final idNumber:', this.idNumber);

    // 加入手機號碼格式驗證
    const cellPhone = memberData?.cell ?? '';
    const hasValidPhone = !!(
      cellPhone &&
      cellPhone !== '0' &&
      /^09.{8}$/.test(cellPhone)
    );

    this.phoneNumber = hasValidPhone ? cellPhone : '';
    const phoneVerifiedStatus = this.sharedStorageService.get(
      STORAGE_KEY.PHONE_VERIFIED_STATUS
    );
    // 若是從設定密碼那邊回來的話
    if (phoneVerifiedStatus && hasValidPhone) {
      this.isPhoneValid = true;
      this.lastVerifiedPhone = this.phoneNumber;
      this.verifyForm.patchValue({
        phone: this.phoneNumber,
      });
      this.sharedStorageService.remove(STORAGE_KEY.PHONE_VERIFIED_STATUS);
    }
    this.email = memberData?.email ?? '';

    console.log('memberData:', memberData);
    console.log('idLoginData:', idLoginData);
    console.log('hasValidPhone:', hasValidPhone);
    console.log('phoneNumber:', this.phoneNumber);
    console.log('email:', this.email);

    // if user has old HIS data and finish the otp verify in previous step, directly fill in value and skip the otp Verification for the form field this member has data
    const loginStatus = this.sharedStorageService.get(STORAGE_KEY.LOGIN_STATUS);
    if (loginStatus === 'withHIS') {
      this.verifyForm.patchValue({
        phone: this.phoneNumber, // 只會是空字串或有效的 10 位數手機
        email: this.email,
      });
      this.verifyForm.updateValueAndValidity();

      this.isPhoneValid = hasValidPhone; // 使用驗證結果
      this.isEmailValid = !!this.email;

      if (hasValidPhone) {
        // 只有有效手機才設定
        this.lastVerifiedPhone = this.phoneNumber;
      }
      if (this.email) {
        this.lastVerifiedEmail = this.email;
      }
    }

    this.verifyForm.get('email')?.valueChanges.subscribe(email => {
      console.log('Email changed to:', email);
      console.log('lastVerifiedEmail:', this.lastVerifiedEmail);
      console.log('emailCondition:', this.emailCondition);
      console.log('isEmailValid:', this.isEmailValid);
      // 只有當信箱真的改變，且與上次驗證的信箱不同時才重置
      if (email !== this.lastVerifiedEmail && this.lastVerifiedEmail !== '') {
        console.log('Resetting email validation status');
        this.emailCondition = -1;
        this.isEmailValid = false;
        this.lastVerifiedEmail = '';
      }
    });
    // 手機號碼變更監聽
    this.verifyForm.get('phone')?.valueChanges.subscribe(phone => {
      console.log('Phone changed to:', phone);
      console.log('lastVerifiedPhone:', this.lastVerifiedPhone);
      console.log('phoneCondition:', this.phoneCondition);
      console.log('isPhoneValid:', this.isPhoneValid);
      // 只有當手機號碼真的改變，且與上次驗證的手機不同時才重置
      if (phone !== this.lastVerifiedPhone && this.lastVerifiedPhone !== '') {
        console.log('Resetting phone validation status');
        this.phoneCondition = -1;
        this.isPhoneValid = false;
        this.lastVerifiedPhone = '';
      }
    });
  }

  dontHavePhone: boolean = false; // 是否沒有手機號碼
  isPhoneValid: boolean = false; // 手機是否完成驗證
  isEmailValid: boolean = false; // 信箱是否完成驗證
  phoneOtpProcessing: boolean = false; // 手機驗證碼是否正在發送中
  emailOtpProcessing: boolean = false; // 信箱驗證碼是否正在發送中

  // 驗證是否皆通過
  get isValidationPass(): boolean {
    return (this.dontHavePhone || this.isPhoneValid) && this.isEmailValid;
  }

  showError: boolean = false;

  /**
   * 測試用數據
   * -1: pass
   * 1: 手機尚未驗證
   */
  private _phoneCondition: number = -1;
  get phoneCondition(): number {
    return this._phoneCondition;
  }
  set phoneCondition(value: number) {
    if (this._phoneCondition !== value && !this.isUpdatingValidation) {
      this._phoneCondition = value;
      this.isUpdatingValidation = true;
      this.verifyForm.get('phone')?.updateValueAndValidity();
      this.isUpdatingValidation = false;
    }
  }

  /**
   * 測試用數據
   * -1: pass
   * 1: 信箱尚未驗證
   * 2: 信箱已被使用
   */
  private _emailCondition: number = -1;
  get emailCondition(): number {
    return this._emailCondition;
  }
  set emailCondition(value: number) {
    if (this._emailCondition !== value && !this.isUpdatingValidation) {
      this._emailCondition = value;
      this.isUpdatingValidation = true;
      this.verifyForm.get('email')?.updateValueAndValidity();
      this.isUpdatingValidation = false;
    }
  }

  // 切換"我沒有手機號碼"
  toggleDontHavePhone(event: MatSlideToggleChange) {
    if (event.checked) {
      this.verifyForm.get('phone')?.setValue('');
      this.verifyForm.get('phone')?.clearValidators();
    } else {
      this.verifyForm
        .get('phone')
        ?.setValidators([
          Validators.required,
          (control: FormControl) => this.phoneValidator(control),
        ]);
    }
    this.verifyForm.get('phone')?.updateValueAndValidity();
    this.dontHavePhone = event.checked;
  }

  // 手機號碼驗證器
  phoneValidator(control: FormControl): ValidationErrors | null {
    const value = control.value;
    if (value) {
      const phoneRegex = /^09\d{8}$/; // 手機號碼須為 09 開頭的 10 位數字
      if (!phoneRegex.test(value)) {
        return {
          invalidFormat: this.translateService.instant(
            'error.phone-error.format'
          ),
        };
      }
      if (this.phoneCondition === 1) {
        this.showPhoneError = true;
        return {
          notValid: this.translateService.instant(
            'error.phone-error.not-valid'
          ),
        };
      }
    }
    return null;
  }

  // 信箱驗證器
  emailValidator(control: FormControl): ValidationErrors | null {
    const value = control.value;
    if (value) {
      if (this.emailCondition === 1) {
        this.showEmailError = true;
        return {
          notValid: this.translateService.instant(
            'error.email-error.not-valid'
          ),
        };
      }
      if (this.emailCondition === 2) {
        return {
          alreadyRegister: this.translateService.instant(
            'error.email-error.already-register'
          ),
        };
      }
    } else {
      return {
        required: this.translateService.instant('error.email-error.required'),
      };
    }
    return null;
  }

  // 獲取手機號碼錯誤訊息
  getPhoneErrorMessage() {
    const control = this.verifyForm.get('phone');
    if (!control || !control.errors || !this.showPhoneError) return '';

    const errors = control.errors;
    if (errors['required']) {
      return this.translateService.instant('error.phone-error.required');
    }
    if (errors['invalidFormat']) {
      return errors['invalidFormat'];
    }
    if (errors['notValid']) {
      return errors['notValid'];
    }
    return '';
  }

  // 獲取信箱錯誤訊息
  getEmailErrorMessage() {
    const control = this.verifyForm.get('email');
    if (!control || !control.errors || !this.showEmailError) return '';

    const errors = control.errors;
    if (errors['required']) {
      return this.translateService.instant('error.email-error.required');
    }
    if (errors['email']) {
      return this.translateService.instant('error.email-error.format');
    }
    if (errors['notValid']) {
      return errors['notValid'];
    }
    if (errors['alreadyRegister']) {
      return errors['alreadyRegister'];
    }
    return '';
  }

  // 發送手機驗證碼
  sendPhoneOtp() {
    this.showPhoneError = true;
    if (this.phoneOtpProcessing) {
      return;
    }

    this.phoneOtpProcessing = true;
    const hasPhoneError =
      this.verifyForm.get('phone')?.hasError('required') ||
      this.verifyForm.get('phone')?.hasError('invalidFormat');

    if (!hasPhoneError) {
      this.registerVerifyContactService
        .registerSendOtp(
          this.idNumber,
          'cell',
          this.verifyForm.get('phone')?.value ?? ''
        )
        .subscribe(res => {
          if (res.statusCode === 'S0000') {
            this.startOtpCooldown(); // 使用統一的倒數

            const otpDialog = this.dialog.open(OtpDialogComponent, {
              disableClose: true,
              data: {
                isOtpPhone: true,
                canSwitch: false,
                phoneNumber: this.verifyForm.get('phone')?.value ?? '',
                idNo: this.idNumber,
                isFromlogin: false,
                showCloseButton: false,
                successAction: () => {
                  this.sharedStorageService.set(
                    STORAGE_KEY.LOGIN_STATUS,
                    'withHIS'
                  );
                  this.showPhoneError = false;
                  this._phoneCondition = -1;
                  this.verifyForm.get('phone')?.updateValueAndValidity();
                  otpDialog.close();
                  this.isPhoneValid = true;
                  this.lastVerifiedPhone =
                    this.verifyForm.get('phone')?.value ?? '';
                  this.phoneOtpProcessing = false;
                },
              },
            });

            otpDialog.afterClosed().subscribe(() => {
              this.phoneOtpProcessing = false;
            });
          } else if (res.statusCode === 'EC5004') {
            this.phoneOtpProcessing = false;
            this.openErrorDialog();
          }
        });
    } else {
      this.phoneOtpProcessing = false;
    }
  }

  // 發送信箱驗證碼
  sendEmailOtp() {
    this.showEmailError = true;
    if (this.emailOtpProcessing) {
      return;
    }

    const hasEmailError =
      this.verifyForm.get('email')?.hasError('required') ||
      this.verifyForm.get('email')?.hasError('invalidFormat');

    if (!hasEmailError) {
      this.emailOtpProcessing = true;
      const email = this.verifyForm.get('email')?.value ?? '';

      this.registerVerifyContactService
        .registerVerifyEmailRegistered(this.idNumber, email)
        .subscribe(res => {
          if (res.statusCode === 'S0000' && !res.data?.isEmailUse) {
            this.startOtpCooldown(); // 使用統一的倒數
            this.sendOtpAfterEmailVerification();
          } else {
            // ... 錯誤處理 ...
            if (res.statusCode === 'S0000') {
              // 檢查 isPass 的值來判斷信箱是否已註冊
              console.log('API 調用成功');
              console.log('res.data:', res.data);
              if (res.data?.isEmailUse) {
                // true 表示已註冊，設定錯誤狀態
                this.emailCondition = 2;
                this.verifyForm.get('email')?.updateValueAndValidity();
                this.lastVerifiedEmail = email;
                this.emailOtpProcessing = false;
                this.toastr.error(
                  this.translateService.instant(
                    'error.email-error.already-register'
                  )
                );
              } else {
                // false 表示未註冊，可以繼續發送OTP
                // this.emailCondition = -1;
                this.emailOtpProcessing = true;
                this.sendOtpAfterEmailVerification();
              }
            } else {
              // API 調用失敗，也設定為錯誤狀態
              console.log('API 調用失敗');
              this.emailCondition = 2;
              this.verifyForm.get('email')?.updateValueAndValidity();
              this.lastVerifiedEmail = email;
              this.emailOtpProcessing = false;
            }
          }
        });
    }
  }

  // 表單提交
  onSubmit() {
    // 错误狀態
    if (!this.isPhoneValid && !this.dontHavePhone) {
      this.showPhoneError = true;
      this._phoneCondition = 1;
    }
    if (!this.isEmailValid) {
      this.showEmailError = true;
      this.emailCondition = 1;
    }

    this.verifyForm.updateValueAndValidity();

    if (this.isValidationPass) {
      const createMemberRequest = this.sharedStorageService.get(
        STORAGE_KEY.CREATE_MEMBER_REQUEST
      );
      if (createMemberRequest) {
        createMemberRequest.cell = this.verifyForm.get('phone')?.value ?? '';
        createMemberRequest.email = this.verifyForm.get('email')?.value ?? '';
        this.sharedStorageService.set(
          STORAGE_KEY.CREATE_MEMBER_REQUEST,
          createMemberRequest
        );
      }

      const queryParams: Record<string, string> = {
        'setting-source': 'create',
      };
      const backToAppointment =
        this.route.snapshot.queryParamMap.get('backToAppointment');
      if (backToAppointment) queryParams['backToAppointment'] = 'true';

      this.router
        .navigate(['/healthcheck/consentform'], { queryParams })
        .then();
    }
  }

  // 開啟錯誤顯示Dialog
  openErrorDialog() {
    const title = this.translateService.instant(
      'error.otp-error.reached-otp-limit'
    );
    const message = '';

    const errorDialog = this.dialog.open(SingleActionDialogComponent, {
      disableClose: true,
      data: {
        title: title,
        message: message,
        showCloseButton: true,
        buttonText: this.translateService.instant('common.button.confirm'),
        action: () => errorDialog.close(),
      },
    });
  }

  // 信箱驗證成功後發送OTP
  private sendOtpAfterEmailVerification() {
    this.registerVerifyContactService
      .registerSendOtp(
        this.idNumber,
        'email',
        this.verifyForm.get('email')?.value ?? ''
      )
      .subscribe(res => {
        if (res.statusCode === 'S0000') {
          const otpDialog = this.dialog.open(OtpDialogComponent, {
            disableClose: true,
            data: {
              isOtpPhone: false,
              canSwitch: false,
              email: this.verifyForm.get('email')?.value ?? '',
              idNo: this.idNumber,
              isFromlogin: false,
              successAction: () => {
                this.sharedStorageService.set(
                  STORAGE_KEY.LOGIN_STATUS,
                  'withHIS'
                );
                this.showEmailError = false;
                otpDialog.close();
                this.emailCondition = -1;
                this.isEmailValid = true;
                this.lastVerifiedEmail =
                  this.verifyForm.get('email')?.value ?? '';
                this.emailOtpProcessing = false;
              },
            },
          });
          otpDialog.afterClosed().subscribe(() => {
            this.emailOtpProcessing = false;
          });
          this.startEmailOtpCooldown();
        } else if (res.statusCode === 'EC5004') {
          // otp attempt reach limit
          this.openErrorDialog();
          this.emailOtpProcessing = false;
        }
      });
  }

  // Email OTP Countdown
  private startEmailOtpCooldown() {
    this.emailOtpCooldown = 30;
    this.cooldownInterval = setInterval(() => {
      this.emailOtpCooldown--;
      if (this.emailOtpCooldown <= 0) {
        clearInterval(this.cooldownInterval);
      }
    }, 1000);
  }

  // Phone OTP Countdown
  private startPhoneOtpCooldown() {
    this.phoneOtpCooldown = 30;
    this.phoneCooldownInterval = setInterval(() => {
      this.phoneOtpCooldown--;
      if (this.phoneOtpCooldown <= 0) {
        clearInterval(this.phoneCooldownInterval);
      }
    }, 1000);
  }

  // 統一的 OTP 倒數方法
  private startOtpCooldown() {
    // 清除舊的 interval
    if (this.otpCooldownInterval) {
      clearInterval(this.otpCooldownInterval);
    }

    // 記錄倒數開始時間
    const startTime = Date.now();
    sessionStorage.setItem('otpCooldownStartTime', startTime.toString());

    this.otpCooldown = 30;
    this.otpCooldownInterval = setInterval(() => {
      this.otpCooldown--;
      if (this.otpCooldown <= 0) {
        clearInterval(this.otpCooldownInterval);
        this.otpCooldown = 0;
        sessionStorage.removeItem('otpCooldownStartTime');
      }
    }, 1000);
  }

  // 恢復倒數計時
  private restoreOtpCooldown() {
    const startTimeStr = sessionStorage.getItem('otpCooldownStartTime');
    if (startTimeStr) {
      const startTime = parseInt(startTimeStr, 10);
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = 30 - elapsed;

      if (remaining > 0) {
        // 還在倒數期間,繼續倒數
        this.otpCooldown = remaining;
        this.otpCooldownInterval = setInterval(() => {
          this.otpCooldown--;
          if (this.otpCooldown <= 0) {
            clearInterval(this.otpCooldownInterval);
            this.otpCooldown = 0;
            sessionStorage.removeItem('otpCooldownStartTime');
          }
        }, 1000);
      } else {
        // 倒數已結束,清除記錄
        sessionStorage.removeItem('otpCooldownStartTime');
        this.otpCooldown = 0;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.otpCooldownInterval) {
      clearInterval(this.otpCooldownInterval);
    }
    // 離開頁面時清除倒數記錄
    sessionStorage.removeItem('otpCooldownStartTime');
  }
}
